import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';

const EMPTY_TYPER = {
  name: '',
  password: '',
  enabled: true,
};

const NewTyperRow = ({ onCreate, formId }) => {
  const [typer, setTyper] = useState(EMPTY_TYPER);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (typer.name && typer.password) {
      await onCreate(typer.name, typer.password, typer.enabled);
      setTyper(EMPTY_TYPER);
    }
  };

  return (
    <tr>
      <td><Form id={formId} onSubmit={onSubmit} /></td>
      <td>
        <Form.Control
          value={typer.name || ''}
          onChange={(e) => setTyper({ ...typer, name: e.target.value })}
          placeholder="New user login"
          required
          form={formId}
        />
      </td>
      <td>
        <Form.Control
          type="password"
          form={formId}
          value={typer.password || ''}
          placeholder="New user password"
          onChange={(e) => setTyper({ ...typer, password: e.target.value })}
          required
        />
      </td>
      <td>
        <Form.Check
          type="checkbox"
          form={formId}
          checked={typer.enabled}
          onChange={() => setTyper({ ...typer, enabled: !typer.enabled })}
        />
      </td>
      <td />
      <td>
        <Button variant="success" form={formId} type="submit">Create</Button>
      </td>
    </tr>
  );
};

NewTyperRow.propTypes = {
  onCreate: PropTypes.func.isRequired,
  formId: PropTypes.string.isRequired,
};

export default NewTyperRow;
